import { numberWithCommas } from "./string";
import { programTypeMapper } from "@tailormed/common-client/util/programTypeMapping";

export const parseFundsMaxToDisplay = (ap) => {
  const { grantTotalCalcType, fundsMax, maxBenefitPerFill } = ap;
  const grantTotalCalcTypes = ["noFundsMax", "oopAsFundsMax"];
  let fundsMaxDisplayedValue = "--";

  const { isManufacturerFreeDrugProgram } = programTypeMapper.getProgramTypeFlags(ap);

  if (!isManufacturerFreeDrugProgram && !grantTotalCalcTypes.some((type) => type === grantTotalCalcType)) {
    const parsedNumber = numberWithCommas(fundsMax);

    if (parsedNumber) {
      fundsMaxDisplayedValue = `$${parsedNumber}${maxBenefitPerFill ? ` / $${maxBenefitPerFill} per fill` : ""}`;
    }
  }

  return fundsMaxDisplayedValue;
};
